/**
 * Created by Jew on 7/31/2017.
 */
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { IdexService } from 'app/idex.service';

declare let $: any;

@Component({
    selector: 'app-move',
    templateUrl: './move.component.html',
    styleUrls: ['./move.component.css'],
})
export class MoveDialogComponent implements OnInit {
    errorMessage: string;
    user: any;
    tin: any;
    item: any;
    info: any;
    selectedItemPath: any;
    parent_folder: any;
    path: any;
    fullPath: any;
    selectId: any;
    selectListId: any[] = [];
    itemSelList: any[] = [];
    isMultiSelect = false;
    isEnable = false;

    constructor(@Inject(MAT_DIALOG_DATA) private data: any, private service: IdexService) {
        this.user = this.service.user;
    }

    ngOnInit() {
        if (this.data.isMultiSelect) {
           const listIds = [];
           this.isMultiSelect = this.data.isMultiSelect;
           this.selectListId = [];
           this.itemSelList = this.data.listItem;
           if (this.itemSelList) {
              if (this.itemSelList.length > 0) {
                 this.item = this.data.listItem[0];
                 this.selectId = this.data.listItem[0].id;
              }
              for (const itemSel of this.itemSelList) {
                 listIds.push(itemSel.id);
              }
           }
           this.selectListId = listIds;
        } else {
           this.item = this.data.item;
           this.selectId = this.item.id;
        }
    }
    expand(folders: any) {
        if (!folders.isExpanded()) {
            folders.toggle();
        }
    }
    selectItem(item: any) {
       this.isEnable = true;
        $('.selectedPath').removeClass('selectedPath');
        if (item.tin) {
            $('#move' + item.tin).addClass('selectedPath');
        } else {
            $('#mainfile').addClass('selectedPath');
        }
        this.tin = item.tin;
        this.path = item.name ? item.name : item.srcElement.innerText || item.target.innerText;
        this.parent_folder = '';
        if (this.selectedItemPath === item) { return; }
        if (this.selectedItemPath) {
            this.selectedItemPath.selected = false;
        }
        this.selectedItemPath = item;
        item.selected = true;
        this.fullPath = item.name;
    }
    move_file() {
        if (!this.path) {
            return;
        } else {
           if (this.isMultiSelect) {
              let notMove = false;
              for (const id of this.selectListId) {
                 if (this.parent_folder === id) {
                    notMove = true;
                    break;
                 }
              }
              this.service.multipleMove(this.selectListId, this.parent_folder, this.tin, this.path, this.fullPath)
                 .subscribe(data => {
                       if (notMove) {
                          this.data.data.movedialog.close(false);
                          this.data.translate.get('alert.cant_move').subscribe(s => {
                             this.data.toast.error(s);
                          });
                       } else {
                          if (data.overallSuccess) {
                             this.data.data.movedialog.close(true);
                             this.data.data.docList.showdocument.emit();
                             this.data.translate.get('alert.multi_move_to').subscribe(s => {
                                this.data.toast.success(s + this.path);
                             });
                          } else {
                             for (const item of data.results) {
                                if (item.fileExist) {
                                   this.data.data.movedialog.close(false);
                                   this.data.translate.get('alert.cant_move_exist').subscribe(s => {
                                      this.data.toast.error(s);
                                   });
                                   break;
                                }
                             }
                          }
                       }
                    }
                 );
           } else {
              this.service.move(this.item.id, this.parent_folder, this.tin, this.path, this.fullPath)
                 .subscribe(data => {
                       this.data.data.movedialog.close(true);
                       this.data.data.showdocument.emit();
                       this.data.translate.get('alert.move_to').subscribe(s => {

                          const name = this.item.fileName ? this.item.fileName : this.item.name;
                          this.data.toast.success(name + s + this.path);
                       });
                    }
                 );
           }
      }
    }

   onSelectPath(agreed: any) {
      $('.selectedPath').removeClass('selectedPath');
      if (agreed.id) {
         $('#move' + agreed.id).addClass('selectedPath');
      }
      this.parent_folder = agreed.id;
      this.path = agreed.name;
      this.fullPath = agreed.path.replace(/\//g, '\\') + this.path;
      this.isEnable = true;
   }
}
